import { TaskType as ApiTaskType } from 'src/api/generated/touring/types';
import { mapLinkableEntityType } from '../common';
import { TaskType } from './types';

export const mapTaskType = (apiTask: ApiTaskType): TaskType => ({
  id: apiTask.id,
  title: apiTask.title,
  description: apiTask.description,
  priority: apiTask.priority,
  status: apiTask.status,
  closeReason: apiTask.closeReason,
  closedBy:
    apiTask.closedBy === null
      ? null
      : mapLinkableEntityType(apiTask.closedBy),
  closedAt: apiTask.closedAt,
  claimedBy:
    apiTask.claimedBy === null
      ? null
      : mapLinkableEntityType(apiTask.claimedBy),
  claimedAt: apiTask.claimedAt,
  createdBy:
    apiTask.createdBy === null
      ? null
      : mapLinkableEntityType(apiTask.createdBy),
  createdAt: apiTask.createdAt,
  context: apiTask.context,
  isUnread: apiTask.isUnread,
  audience: apiTask.audience.map(mapLinkableEntityType),
});
